import { render, staticRenderFns } from "./Terzisti.vue?vue&type=template&id=4f1819c4&scoped=true&"
import script from "./Terzisti.vue?vue&type=script&lang=js&"
export * from "./Terzisti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1819c4",
  null
  
)

export default component.exports